import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Avatar,
  AppBar,
  Box,
  IconButton,
  Hidden,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import InputIcon from "@mui/icons-material/Input";
// import WelcomeUser from "../pages/WelcomeUser/Welcomeuser";
import ImageUpload from "./ImageUpload.js";

const user = {
  avatar: "/static/images/avatars/userimg.png",
  avatar1: "/static/images/avatars/zippy.png",
  email: localStorage.getItem("email"),
  name: localStorage.getItem("user"),
  group: localStorage.getItem("group"),
};

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const [useravatar, setUserAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/usrimage/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setUserAvatar(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [orname, setOrname] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgname/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {
        setOrname(resp);
        localStorage.setItem("org", resp);
      })
      .catch((error) => {
        console.error(error);
        //window.location.href = "/something_went_wrong";
      });
  }, []);

  const [userlogin, setUserlogin] = React.useState([]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/userstatuscheck/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setUserlogin(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/availableBalance/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => localStorage.setItem("available", resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const logout = () => {
    localStorage.clear();
    window.localStorage.clear();
    if (user.group === "trainer" || user.group === "trainee") {
      window.location.href = `/${orname}`;
    } else {
      window.location.href = "/";
    }
  };

  const navicons = (
    <>
      <Avatar
        src={useravatar.cover}
        sx={{
          cursor: "pointer",
          width: 28,
          height: 28,
        }}
        to="/app/runninglabs"
      />
      <Typography className="px-1" color="#ffff" variant="body2">
        {localStorage.getItem("email")}
      </Typography>
      <IconButton
        color="inherit"
        title="Logout"
        aria-label="Logout"
        onClick={logout}
        to={user.group === "trainer" || user.group === "trainee" ? "/login" : `/${orname}`}
        tag={RouterLink}
      >
        <InputIcon />
      </IconButton>
    </>
  );

  return (
    <AppBar elevation={0} {...rest}>
      <Toolbar style={{ minHeight: "60px", background: "#06396c" }}>
        <ImageUpload />

        <div
          className="d-table mr-auto ml-2"
          style={{
            alignItems: "center",
            fontSize: 18,
            fontWeight: 800,
            color: "#ffff",
            fontFamily: "sans-serif",
            paddingLeft: "5px",
          }}
        >
          LabAsService
        </div>
        <Box sx={{ flexGrow: 1 }} />
        {/* <WelcomeUser userlogin={userlogin} /> */}
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden lgDown>{navicons}</Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;
